import React from 'react';
import { equals, find, propEq } from 'ramda';
import { DeleteOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import classNames from 'classnames';
import { TEAM_ROLES } from '../../../../../lib/rights';
import { RoleLabelEnum, RoleValueEnum, ARCHIVED_LABEL_SUFFIX } from '../../../../../components/users/utils/roles';

const RoleCardItem = ({
  team,
  offer,
  role,
  roleValue,
  onDelete,
  isAdministration,
  isArchived
}) => {
  const color = find(propEq(roleValue, 'value'), TEAM_ROLES).color;
  const isAllTeams = equals(RoleValueEnum.ALL, team);
  const isAllOffers = equals(RoleValueEnum.ALL, offer);
  const offerLabel = isArchived ? `${offer} ${ARCHIVED_LABEL_SUFFIX}` : offer;

  return (
    <div className="flex justify-between bg-flexi-col-table px-3 py-4 rounded-xl">
      <div className="flex flex-col gap-1 justify-center">
        {isAdministration && <p>{isAllTeams ? RoleLabelEnum.ALL_TEAMS : team}</p>}
        {offer && <p className={classNames({ 'text-flexi-grey': isAdministration })}>{isAllOffers ? RoleLabelEnum.ALL_OFFERS : offerLabel}</p>}
      </div>
      <div className="flex items-center gap-3">
        <span className={`text-${color} bg-${color}-bg py-1 px-2 rounded-3xl`}>{role}</span>
        {onDelete && (
          <Button
            onClick={onDelete}
            ghost className="border-0 shadow-none" type="danger"
            shape="circle" icon={<DeleteOutlined className="text-xl" />}
          />
        )}
      </div>
    </div>
  );
};

export default RoleCardItem;